import React from "react";
import { useSelector } from "react-redux";

// Components
import { Modal } from "@octopus-investments/deep-sea-components";

// Tools
import { ADVISER_PHONE, INVESTOR_PHONE } from "utils/constants";
import { isEmptyObj } from "utils/helpers";

// Styles
import "./ServerError.scss";

export default function ServerError() {
  const apiErrors = useSelector(({ apiErrors }) => apiErrors);
  const showModal = !isEmptyObj(apiErrors);
  return (
    showModal && (
      <Modal
        className="server-error-modal"
        id="ServerErrorModal"
        showModal={showModal}
        showCloseIcon={false}
      >
        <h3 className="coheadline">Something went wrong and we're working to fix it.</h3>

        <div className="information-block">
          <p>Sorry we couldn't load your details. Please try again by refreshing the page.</p>
          <p>
            If you need help straight away, get in touch. If you're an investor, please call{" "}
            {INVESTOR_PHONE}. If you're an adviser, please call {ADVISER_PHONE}.
          </p>
        </div>
      </Modal>
    )
  );
}
